export const LOCK_MODAL_STEPS = {
  confirmation: "confirmation",
  form: "form",
} as const;

export type LockModalStep = (typeof LOCK_MODAL_STEPS)[keyof typeof LOCK_MODAL_STEPS];
